export const GLOBAL_URL = 'https://api.unipack.group/';
export const IMAGE_URL = 'https://images.unipack.group/';
